// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].rules[0].oneOf[1].use[0]!../../../../../../node_modules/.pnpm/postcss-loader@8.2.0_postcss@8.5.23_typescript@5.9.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[5].rules[0].oneOf[1].use[1]!../event-form/event-form.component.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.danger-shell {
  max-width: 880px;
  margin: 0 auto;
}

.badge--danger {
  background: rgba(239, 68, 68, 0.12);
  border: 1px solid rgba(239, 68, 68, 0.28);
  color: #b91c1c;
}

.pill-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 10px;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 999px;
  background: #f8fafc;
  border: 1px solid rgba(12, 20, 39, 0.08);
  color: #111827;
  font-weight: 700;
}

.pill .dash,
.pill .dot {
  color: #9ca3af;
}

.pill .muted {
  color: #4b5563;
  font-weight: 600;
}

.alert-fieldset {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.04), #ffffff);
  border-color: rgba(239, 68, 68, 0.18);
}

.alert-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid rgba(239, 68, 68, 0.2);
  background: #fff1f2;
}

.alert-box i {
  color: #b91c1c;
  font-size: 22px;
  line-height: 1;
  margin-top: 2px;
}

.alert-box__title {
  margin: 0 0 4px;
  font-weight: 700;
  color: #991b1b;
}

.alert-box__text {
  margin: 0;
  color: #6b7280;
  font-size: 13px;
}

.form-actions .btn.danger,
.form-actions app-progress-button ::ng-deep button.danger {
  background: linear-gradient(135deg, #ef4444, #f97316);
  color: #0b0f1a;
  box-shadow: 0 12px 24px rgba(239, 68, 68, 0.28);
}

.form-actions app-progress-button ::ng-deep button.danger:hover {
  box-shadow: 0 14px 30px rgba(239, 68, 68, 0.32);
}
`, "",{"version":3,"sources":["webpack://./projects/admin/src/layouts/event-layout/event-confirmation-form/event-confirmation-form.component.css"],"names":[],"mappings":"AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qEAAqE;EACrE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,qDAAqD;EACrD,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":["@import '../event-form/event-form.component.css';\n\n.danger-shell {\n  max-width: 880px;\n  margin: 0 auto;\n}\n\n.badge--danger {\n  background: rgba(239, 68, 68, 0.12);\n  border: 1px solid rgba(239, 68, 68, 0.28);\n  color: #b91c1c;\n}\n\n.pill-row {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 10px;\n}\n\n.pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 10px;\n  border-radius: 999px;\n  background: #f8fafc;\n  border: 1px solid rgba(12, 20, 39, 0.08);\n  color: #111827;\n  font-weight: 700;\n}\n\n.pill .dash,\n.pill .dot {\n  color: #9ca3af;\n}\n\n.pill .muted {\n  color: #4b5563;\n  font-weight: 600;\n}\n\n.alert-fieldset {\n  background: linear-gradient(135deg, rgba(239, 68, 68, 0.04), #ffffff);\n  border-color: rgba(239, 68, 68, 0.18);\n}\n\n.alert-box {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px;\n  border-radius: 12px;\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  background: #fff1f2;\n}\n\n.alert-box i {\n  color: #b91c1c;\n  font-size: 22px;\n  line-height: 1;\n  margin-top: 2px;\n}\n\n.alert-box__title {\n  margin: 0 0 4px;\n  font-weight: 700;\n  color: #991b1b;\n}\n\n.alert-box__text {\n  margin: 0;\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.form-actions .btn.danger,\n.form-actions app-progress-button ::ng-deep button.danger {\n  background: linear-gradient(135deg, #ef4444, #f97316);\n  color: #0b0f1a;\n  box-shadow: 0 12px 24px rgba(239, 68, 68, 0.28);\n}\n\n.form-actions app-progress-button ::ng-deep button.danger:hover {\n  box-shadow: 0 14px 30px rgba(239, 68, 68, 0.32);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
